<template>
    <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="50%"
        :before-close="closeDialog">
        教程内容
    </el-dialog>
</template>
<script>
export default{
    data() {
        return {
            title: '同步教程',
            dialogVisible: false
        }
    },
    methods: {
        closeDialog() {
            this.dialogVisible  = false
        },
        openDialog() {
            this.dialogVisible = true
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/console/components/CourseDialog.vue